import { Link } from "react-router-dom";
import BaseCellRenderer, { IBaseCellRendererParams } from "./BaseCellRenderer";
import { getMainColors } from "../../../constants/colors";

type LinkCellRendererProps = IBaseCellRendererParams<string> & {
    href: string;
    target?: string;
}

export default function LinkCellRenderer(props: LinkCellRendererProps) {
    return (
        <BaseCellRenderer {...props}>
            <Link className="link-cell-renderer" to={props.href} target={props.target}>{props.valueFormatted ?? props.value ?? ""}</Link>
        </BaseCellRenderer>
    );
}